export default {
  env: {
    SITE_URL: process.env.SITE_URL || process.env.VUE_APP_SITE_URL || window.SITE_URL || null,
    API_URL: process.env.API_URL || process.env.VUE_APP_API_URL || window.API_URL || null,
    AUTH_CLIENT_ID: process.env.AUTH_CLIENT_ID || process.env.VUE_APP_AUTH_CLIENT_ID || window.AUTH_CLIENT_ID || null,
    AUTH_CLIENT_SECRET: process.env.AUTH_CLIENT_SECRET || process.env.VUE_APP_AUTH_CLIENT_SECRET || window.AUTH_CLIENT_SECRET || null,
    AUTH_CLIENT_REDIRECT_URI: process.env.AUTH_CLIENT_REDIRECT_URI || process.env.VUE_APP_AUTH_CLIENT_REDIRECT_URI || window.AUTH_CLIENT_REDIRECT_URI || null,
    LOGOUT_URL: process.env.LOGOUT_URL || process.env.VUE_APP_LOGOUT_URL || window.LOGOUT_URL || null,
    API_TIMEOUT: process.env.API_TIMEOUT || process.env.VUE_APP_API_TIMEOUT || window.API_TIMEOUT || null,
    MERCURE_HUB_URL: process.env.MERCURE_HUB_URL || process.env.VUE_APP_MERCURE_HUB_URL || window.MERCURE_HUB_URL || null
  }
};